import { useField } from 'formik';
import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import FormikFormErrorHandler from './FormikFormErrorHandler';
import Select from 'react-select';

interface IProps {
  children: React.ReactNode;
  className: string;
  'data-testid'?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  options: Array<{ Id: number | string; Name: string; hidden?: boolean }>;
  label: string;
  typeofoptionid: string;
  changeHandler?: (value: any) => void;
}

const FormikFormSearchSelectField = (props: IProps) => {
  const [focus, setFocus] = useState(false);
  const [field, meta, helpers] = useField(props);
  const errorClass = `${meta.error && meta.touched ? 'error' : ''}`;

  const { typeofoptionid } = props;

  useEffect(() => {
    setFocus(field.value !== '');
  }, [field.value]);

  const value = props.options.find(
    (op) =>
      op.Id ===
      (typeofoptionid === 'string' ? field.value : parseInt(field.value))
  );
  const selectedValue = value
    ? {
      label: value.Name,
      value: value.Id,
      key: value.Id,
    }
    : null;

  return (
    <div data-testid={props['data-testid']}>
      <Select
        {...props}
        {...field}
        onFocus={(e: any) => {
          setFocus(true);
          const input = e.target;
          if (input instanceof HTMLInputElement) {
            const moveCursorToEnd = () => {
              try {
                const len = input.value.length;
                input.setSelectionRange(len, len);
                input.selectionStart = len;
                input.selectionEnd = len;
                input.scrollLeft = input.scrollWidth;
              } catch (err) {
                // Ignore if type doesn't support selection
              }
            };
            moveCursorToEnd();
            setTimeout(moveCursorToEnd, 10);
            setTimeout(moveCursorToEnd, 100);
          }
        }}
        onBlur={() => setFocus(field.value !== '')}
        isDisabled={props.disabled}
        isClearable={true}
        value={selectedValue}
        options={props.options
          .filter((option) => !option.hidden)
          .map((option) => {
            return {
              label: option.Name,
              value: option.Id,
              key: option.Id,
            };
          })}
        // inputId="ss-input"
        classNamePrefix="search-select"
        className={props.className + ' ' + errorClass}
        onChange={(option: any) => {
          const val = option
            ? option.value
            : typeofoptionid === 'string'
              ? ''
              : -1;
          props.changeHandler?.(val);
          helpers.setValue(val);
        }}
        aria-label={props['data-testid']}
      />
      {props.label?.length > 0 && (
        <label className={`${focus ? 'label-focus' : ''}`}>
          <span>
            <FormattedMessage id={props.label} />
          </span>
        </label>
      )}
      <FormikFormErrorHandler
        intl={props.intl}
        meta={meta}
      />
    </div>
  );
};

export default injectIntl(FormikFormSearchSelectField);
